//React Library
import React, { useState, useEffect } from "react";

//Material UI Styles
import { lighten, makeStyles, styled } from "@material-ui/core/styles";

//Material UI Components
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Tooltip from "@material-ui/core/Tooltip";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Popover from "@material-ui/core/Popover";
import Select from "@material-ui/core/Select";
import Menu from "@material-ui/core/Menu";
import { CircularProgress } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import MuiPhoneNumber from "material-ui-phone-number";
import Visibility from "@material-ui/icons/Visibility";
import FormControl from "@material-ui/core/FormControl";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import CustomToolTip from "../../Global/PasswordGuileline";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Table from "@material-ui/core/Table";
import Container from "@material-ui/core/Container";
import moment from "moment";
import Typography from "@material-ui/core/Typography";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import DeleteIcon from "@material-ui/icons/Delete";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";

import { Switch } from "@material-ui/core";
import StartIcon from "@material-ui/icons/Check";
import EditIcon from "@material-ui/icons/Edit";

//Child Components
import Sidebar from "./PreviewSidebar";
import MoreOptionDailog from "../templateTools/MoreOptionDailog";
import MiddleHeader from "../middleHeader/middleHeader";

//Global Elements
import GlobalApi from "../../Global";
import Colors from "../../Global/colors";
import refresh_token from "../../Global/refresh_token";
import Spinner from "../../Global/Spinner2";
import DarkButton from "../../Global/DarkButton";
import NoRecords from "../../Global/NoRecords";

//Custom Css + Images
import "./templateArchives.css";
import swal from "@sweetalert/with-react";
import Delete from "../../Assets/delete.png";
import DeleteG from "../../Assets/deleteG.png";
import dots from "../../Assets/dots.png";
import dotsH from "../../Assets/dotsH.png";
import pencil from "../../Assets/pencil.png";
import pencilG from "../../Assets/pencilG.png";
import start from "../../Assets/start.png";
import startG from "../../Assets/startG.png";
import search from "../../Assets/search.png";
import file from "../../Assets/file.png";
import restore from "../../Assets/restore.png";
import restoreG from "../../Assets/restoreG.png";
import share from "../../Assets/share.png";
import timetable from "../../Assets/timetable.png";
import add from "../../Assets/add.png";
import filter from "../../Assets/Filter_Icon.png";
import {useTranslation} from "react-i18next";

//React Router
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";

//Redux
import { addTeam } from "../../Redux/Actions/teamAction";
import { useSelector, useDispatch } from "react-redux";

//Others
import uuid from "react-uuid";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    maxHeight: "53vh",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  input: {
    display: "none",
  },
  textField: {
    backgroundColor: Colors.globalColor5,
    border: "none",
    borderRadius: 5,
  },
  resize: {
    padding: "12px",
    fontSize: "12px",
  },
  password: {
    padding: "2px",
  },
  switchBase: {
    color: "#818181",
    padding: "1px",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#043077",
      },
    },
  },
  thumb: {
    color: "white",
    width: "20px",
    height: "20px",
    margin: "1px",
  },
  track: {
    borderRadius: "20px",
    width: "200px",
    backgroundColor: "#818181",
    opacity: "1 !important",
    "&:after, &:before": {
      color: "white",
      fontSize: "11px",
    },
    "&:after": {
      content: "'activate'",
      left: "7px",
    },
    "&:before": {
      content: "'deactivate'",
      right: "8px",
    },
  },
  checked: {
    color: "#043077 !important",
    transform: "translateX(50px) !important",
  },
}));

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

function TemplateArchives() {
  const {t} = useTranslation();
  const language = useSelector((state) => state.languageReducer.language);
  const classes = useStyles();
  const [templates, setTemplates] = useState([]);
  const [accessWith, setAccessWith] = useState([]);
  const [sharedWith, setSharedWith] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [userFilter, setUserFilter] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageNo, setPageNo] = useState(0);
  const [filterApplied, setFilterApplied] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Access: false,
    Users: false,
  });
  const [currentEditRow, setCurrentEditRow] = React.useState({});
  const [datesFilters, setDateFilters] = React.useState({
    today: false,
    yesterday: false,
    last7: false,
    last15: false,
    lastMonth: false,
    startFlag: false,
    endFlag: false,
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });
  const [industries, setIndustries] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedAccess, setSelectedAccess] = useState([]);
  const [token, setToken] = useState("");
  const [currentIndustry, setCurrentIndustry] = useState("");
  const [packageDetails, setPackageDetails] = useState({});
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [tempLoader, setTempLoader] = useState(false);
  const [loader, setLoader] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [currentUser, setCurrentUser] = useState({});
  const [team, setTeam] = useState([]);
  const [permissions_obj, setPermissionObj] = useState({});
  const [teamArr, setTeamArr] = useState([]);
  const [currentCompany, setCurrentCompany] = useState({});
  let history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterMenu1, setFilterMenu1] = useState(null);
  const [filterMenu2, setFilterMenu2] = useState(null);
  const [filterMenu3, setFilterMenu3] = useState(null);
  const [filterMenu4, setFilterMenu4] = useState(null);
  var blank_template = [
    {
      id: uuid(),
      title: "Title Page",
      type: "fixed section",
      position: 1,
      status: "New",

      checklist: {
        template: { id: uuid() },
        list: [
          {
            id: "New-" + uuid(),
            title: "Conducted on",
            dataType: "DateTime",
            position: 1,
            status: "New",
            responseLibrary: [],
            mandatory: false,
            multiselection: false,
            condition: "",
            conditionValue: "",
            conditional: "no",
            parent: null,
            isopen: "no",
            conditionalList: [],
          },
          {
            id: "New-" + uuid(),
            title: "Prepared by",
            dataType: "Text field",
            position: 2,
            status: "New",
            responseLibrary: [],
            mandatory: false,
            multiselection: false,
            condition: "",
            conditionValue: "",
            conditional: "no",
            parent: null,
            isopen: "no",
            conditionalList: [],
          },
          {
            id: "New-" + uuid(),
            title: "Location",
            dataType: "Location",
            position: 3,
            status: "New",
            responseLibrary: [],
            mandatory: false,
            multiselection: false,
            condition: "",
            conditionValue: "",
            conditional: "no",
            parent: null,
            isopen: "no",
            conditionalList: [],
          },
        ],
      },
    },
    {
      id: uuid(),
      title: "Inspection",
      type: "section",
      position: 2,
      status: "New",
      checklist: {
        template: { id: uuid() },
        list: [
          {
            id: "New-" + uuid(),
            title: "",
            dataType: "Text field",
            position: 1,
            status: "New",
            responseLibrary: [],
            mandatory: false,
            multiselection: false,
            condition: "",
            conditionValue: "",
            conditional: "no",
            parent: null,
            isopen: "no",
            conditionalList: [],
          },
        ],
      },
    },
  ];

  const handleScroll = (e) => {
    let currentRecords = rows?.length;
    const bottom =
      e.target.scrollHeight - Math.ceil(e.target.scrollTop) ===
      e.target.clientHeight;
    const top = e.target.scrollTop == 0;
    if (bottom) {
      if (currentRecords < totalRecords) {
        let _pageNo = pageNo + 1;

        if (
          datesFilters.today == true ||
          datesFilters.yesterday == true ||
          datesFilters.last7 == true ||
          datesFilters.last15 == true ||
          datesFilters.lastMonth == true ||
          datesFilters.startFlag == true ||
          datesFilters.endFlag == true
        ) {
          setFilterApplied(true);
          getMoreTemplates(currentCompany, false, _pageNo);
        } else {
          setFilterApplied(false);
          getMoreTemplates(currentCompany, true, _pageNo);
        }
      }
    }
  };

  const getPermissions = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data !== null) {
      let params = { company_id: company?.id, user_id: data?.user_id };
      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      fetch(GlobalApi + "/User/get_user_permission_of_company?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          console.log(response);
          if (response.msg === "success") {
            let permissionsObj = {};
            await response.data.map((v) => {
              permissionsObj[(v.title)] = true;
            });

            console.log("Apple", permissionsObj)

            setPermissionObj(permissionsObj);
            setLoader(false);
          } else if (
            response.error === "jwt expired" ||
            response.error === "invalid token" ||
            response.error === "invalid signature" ||
            response.error === "jwt malformed" ||
            response.error === "Unexpected token"
          ) {
            let status = await refresh_token();
            // console.log(status);
            if (status) {
              // console.log("opopopop");
              getPermissions();
            }
          }
        })
        .catch((error) => {
          // localStorage.clear();
          // window.location.replace("/signin");
          console.log(error.message);
        });
    } else {
      setLoader(false);
    }
  };

  const handleClick2 = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClick3 = (event) => {
    setFilterMenu1(event.currentTarget);
  };
  const handleClick4 = async (event) => {
    setFilterMenu2(event.currentTarget);
    setFilterMenu3(null);
    setFilterMenu4(null);
  };

  const handleClick5 = async (event) => {
    setFilterMenu2(null);
    setFilterMenu3(event.currentTarget);
    setFilterMenu4(null);
  };

  const handleClick6 = async (event) => {
    setFilterMenu2(null);
    setFilterMenu3(null);
    setFilterMenu4(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl(null);
  };

  const handleClose3 = () => {
    setFilterMenu1(null);
  };

  const handleClose4 = () => {
    setFilterMenu2(null);
  };

  const handleClose5 = () => {
    setFilterMenu3(null);
  };

  const handleClose6 = () => {
    setFilterMenu4(null);
  };

  const open = Boolean(filterMenu1);
  const open2 = Boolean(filterMenu2);
  const open3 = Boolean(filterMenu3);
  const open4 = Boolean(filterMenu4);

  const selectUsers = (checked, item) => {
    const nextselectedUsers = checked
      ? [...selectedUsers, item.id]
      : selectedUsers.filter((t) => t !== item.id);
    setSelectedUsers(nextselectedUsers);
  };

  const selectAccess = (checked, item) => {
    const nextselectedAccess = checked
      ? [...selectedAccess, item]
      : selectedAccess.filter((t) => t !== item);
    setSelectedAccess(nextselectedAccess);
  };

  const handleDone = () => {
    try{
      document.getElementById("TemplateScroll").scrollTo(0, 0);
    }catch{
      console.log("error")
    }
    console.log(datesFilters);
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      setFilterApplied(true);
      getTemplates(currentCompany);
    } else {
      setFilterApplied(false);
      getTemplates(currentCompany, true);
    }
    setFilterMenu1(null);
    setFilterMenu2(null);
    setFilterMenu3(null);
    setFilterMenu4(null);

    if (selectedAccess.length > 0) {
      setAppliedFilters({ ...appliedFilters, Access: true });
    } else if (selectedUsers.length > 0) {
      setAppliedFilters({ ...appliedFilters, Users: true });
    } else if (selectedAccess.length == 0) {
      setAppliedFilters({ ...appliedFilters, Access: false });
    } else if (selectedUsers.length == 0) {
      setAppliedFilters({ ...appliedFilters, Users: false });
    }
  };

  const handleDone2 = () => {
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      setFilterApplied(true);
      getTemplates(currentCompany);
    } else {
      setFilterApplied(false);
      getTemplates(currentCompany, true);
    }
    try{
      document.getElementById("TemplateScroll").scrollTo(0, 0);
    }catch{
      console.log("error")
    }
    setFilterMenu1(null);
    setFilterMenu2(null);
    setFilterMenu3(null);
    setFilterMenu4(null);
  };

  const handleToday = () => {
    let _datesFilters = {
      ...datesFilters,
      today: !datesFilters.today,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };

    setDateFilters(_datesFilters);
  };

  const handleYesterday = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: !datesFilters.yesterday,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
      endDate: moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
    };
    setDateFilters(_datesFilters);
  };

  const handle7Days = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: !datesFilters.last7,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };

    setDateFilters(_datesFilters);
  };

  const handle15Days = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: !datesFilters.last15,
      lastMonth: false,
      startDate: moment()
        .subtract(15, "days")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
    setDateFilters(_datesFilters);
  };

  const handle1Month = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: !datesFilters.lastMonth,
      startFlag: false,
      endFlag: false,
      startDate: moment()
        .subtract(1, "month")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };

    setDateFilters(_datesFilters);
  };

  const handleStartDate = (e) => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: true,
      startDate: e.target.value,
    };
    console.log(_datesFilters);

    setDateFilters(_datesFilters);
  };

  const handleEndDate = (e) => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      endFlag: true,
      endDate: e.target.value,
    };
    setDateFilters(_datesFilters);
  };

  const deleteTemplate = (currentEditTemplate) => {
    console.log("currentEditInspection", currentEditTemplate);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;

    swal({
      title: t("Are you sure?"),
      text: t("You will not be able to restore this Template!"),
      icon: "warning",
      buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
      dangerMode: true,
    }).then(async function(isConfirm) {
      if (isConfirm) {
        try {
          fetch(
            GlobalApi +
              "/Template/delete_template/" +
              currentEditTemplate,
            {
              method: "GET",
              headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
              },
            }
          )
            .then((responseJson) => responseJson.json())
            .then(async (response) => {
              console.log("DELETE RESPONSE", response);
             if(response.status =='Success'){
               handleClose2();
             
              swal(
                t("Success"),
                t("Template Has Been Deleted"),
                "success"
              );
              getTemplates(company, true);
              // getFileSize();
             }
            })
            .catch((error) => console.log(error.message));
        } catch (err) {
          console.log(err);
        }
      } else {
        console.log("Canceled");
      }
    });
  };
  const restoreTemplate = (currentEditTemplate) => {
    console.log("currentEditInspection", currentEditTemplate);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;

    swal({
      title: t("Are you sure?"),
      text: t("you want to restore this Inspection!"),
      icon: "warning",
      buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
      dangerMode: true,
    }).then(async function(isConfirm) {
      if (isConfirm) {
        try {
          console.log("DELETE RESPONSE")
          fetch(GlobalApi + "/Template/restore_template/" + currentEditTemplate,
            {
              method: "GET",
              headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
              },
            }
          )
            .then((responseJson) => responseJson.json())
            .then(async (response) => {
              console.log("DELETE RESPONSE", response);
              if (response.status == "Success") {
                handleClose2();

                swal(t("Success"), t("Template Has Been Restored"), "success");

                getTemplates(company, true);
              }
            })
            .catch((error) => console.log(error.message));
        } catch (err) {
          console.log(err);
        }
      } else {
        console.log("Canceled");
      }
    });
  };

  const onSelectUser = () => {
    setFilterMenu1(null);
    setFilterMenu2(null);
    setFilterMenu3(null);
    setFilterMenu4(null);
    getTemplates(currentCompany);
  };

  const onSelectAccess = () => {
    setFilterMenu1(null);
    setFilterMenu2(null);
    setFilterMenu3(null);
    setFilterMenu4(null);
    getTemplates(currentCompany);
  };

  const headCells = [
    {
      id: "name",
      numeric: true,
      disablePadding: false,
      label: t("Template Title"),
      borderLeft: false,
      borderRight: false,
    },
    {
      id: "status",
      numeric: false,
      disablePadding: false,
      label: t("Status"),
      borderLeft: true,
      borderRight: true,
    },
    {
      id: "scheduled",
      numeric: false,
      disablePadding: false,
      label: t("Scheduled"),
      borderLeft: false,
      borderRight: false,
    },
    {
      id: "modified",
      numeric: false,
      disablePadding: false,
      label: t("Last Modified"),
      borderLeft: true,
      borderRight: language == "ar" ? true : false,
    },
    // { id: "edit", numeric: true, disablePadding: false, label: " " },
    // { id: "Preview", numeric: true, disablePadding: false, label: " " },
 
    {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: t("Actions"),
      borderLeft: true,
      borderRight: false,
    },
  ];

  const addSection = (
    title,
    template_id,
    user,
    checklist,
    token,
    type,
    position
  ) => {
    var obj = {
      title: title,
      template_id: template_id,
      status: "active",
      created_by: user,
      type: type,
      position: position,
    };
    var token = token;
    console.log("create section Api called");
    fetch(GlobalApi + "/Section/create_section", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log("response from create Section", res);
        if (res.status === "Success") {
          //===================== Add checklist===============//
          await checklist.map((item) => {
            //alert(JSON.stringify(item.responseLibrary.responses))
            // if (item.status == "New")
            addChecklistItem(
              item.title,
              res.data.id,
              user,
              item.position,
              item.dataType,
              token,
              item.responseLibrary,
              item.mandatory,
              item.multiselection,
              item.condition,
              item.conditionValue,
              item.conditional,
              item.parent,
              item.conditionalList,
              item.type,
              item.is_subquestion,
              item.subQuestionList,
            );
          });

          //==================================================//
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            addSection(title, template_id, user, checklist, token);
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const addResponseLibrary = (
    title,
    check_id,
    response_id,
    user,
    token,
    status
  ) => {
    var obj = {
      title: title,
      check_id: check_id,
      response_id: response_id,
      status: "active",
      created_by: user,
      delete: status,
    };
    var token = token;
    console.log("create response library api called");
    fetch(GlobalApi + "/ResponseSet/create_response_set", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log("response of create response set", res);
        if (res.status === "Success") {
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            addResponseLibrary(title, check_id, response_id, user, token);
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const addChecklistItem = (
    title,
    section_id,
    user,
    position,
    dataType,
    token,
    responseLibrary,
    mandatory,
    multiselection,
    condition,
    conditionValue,
    conditional,
    parent,
    conditionalList,
    type,
    is_subquestion,
    subQuestionList,
  ) => {
    var obj = {
      title: title,
      section_id: section_id,
      status: "active",
      created_by: user,
      position: position,
      data_type: dataType,
      is_mandatory: mandatory,
      is_multiple_allowed: multiselection,
      condition: condition,
      condition_value: conditionValue,
      is_conditional: conditional,
      parent_id: parent,
      type: type,
      is_subquestion: is_subquestion,
      
    };
    var token = token;
    console.log("create checklist api called");
    fetch(GlobalApi + "/CheckList/create_check_list", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log("response of create checklist", res);
        if (res.status === "Success") {
          //===================== Add checklist===============//
          if (dataType == "Custom" || dataType == "Global") {
            await responseLibrary.responses.map((r, index) => {
              addResponseLibrary(
                r.title,
                res.data.id,
                r.id,
                user,
                token,
                index == 0 ? true : false
              );
            });
          }
          //==================================================//
          //===================== Add Conditional checklist===============//
          if (conditional == "yes") {
            conditionalList.map((item) => {
              // if (item.status == "New")
              addChecklistItem(
                item.title,
                section_id,
                user,
                item.position,
                item.dataType,
                token,
                item.responseLibrary,
                item.mandatory,
                item.multiselection,
                item.condition,
                item.conditionValue,
                item.conditional,
                res.data.id,
                [],
                item.type,
                item.is_subquestion,
                [],
              );

              if (item.status == "changed" || item.status == "deleted") {
              }
              // updateChecklistItem(
              //   item.title,
              //   section_id,
              //   user,
              //   item.position,
              //   item.dataType,
              //   token,
              //   item.responseLibrary,
              //   item.status,
              //   item.id,
              //   item.mandatory,
              //   item.multiselection,
              //   item.condition,
              //   item.conditionValue,
              //   item.conditional,
              //   item.parent
              // );
            });
          }

          if (is_subquestion == "yes") {
            subQuestionList.map((item) => {
              // if (item.status == "New")
              addChecklistItem(
                item.title,
                section_id,
                user,
                item.position,
                item.dataType,
                token,
                item.responseLibrary,
                item.mandatory,
                item.multiselection,
                item.condition,
                item.conditionValue,
                item.conditional,
                res.data.id,
                [],
                item.type,
                item.is_subquestion,
                [],
              );

              if (item.status == "changed" || item.status == "deleted") {
              }
              // updateChecklistItem(
              //   item.title,
              //   section_id,
              //   user,
              //   item.position,
              //   item.dataType,
              //   token,
              //   item.responseLibrary,
              //   item.status,
              //   item.id,
              //   item.mandatory,
              //   item.multiselection,
              //   item.condition,
              //   item.conditionValue,
              //   item.conditional,
              //   item.parent
              // );
            });
          }

          //==================================================//
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            addChecklistItem(
              title,
              section_id,
              user,
              position,
              dataType,
              token,
              responseLibrary,
              mandatory,
              multiselection,
              condition,
              conditionValue,
              conditional,
              parent,
              conditionalList,
              type,
              is_subquestion,
              subQuestionList,
            );
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const createCustomTemplate = async (template) => {
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data.token == null) {
      return <Redirect to={"/signin"} />;
    }

    var user = data.user_id;
    var obj = {
      title: "Untitled Template", //organization_id:'408576c3-0471-467e-9f55-f4c44bb54c6e',
      company_id: currentCompany.id,
      description: "Add Description",
      status: "draft",
      created_by: user,
    };
    console.log("create template APi called");

    var token = data.token;
    fetch(GlobalApi + "/Template/create_template", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log("response of create template", res);
        if (res.msg === "success") {
          console.log("create template share APi called");
          fetch(GlobalApi + "/TemplateShare/create_template_share", {
            method: "post",
            headers: new Headers({
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              user_id: user,
              company_id: res.data.organization_id,
              template_id: res.data.id,
              isOwner: true,
              isEditor: true,
            }),
          });
          await blank_template.map(async (section) => {
            // if (section.status == "New")
            await addSection(
              section.title,
              res.data.id,
              user,
              section.checklist.list,
              token,
              section.type,
              section.position
            );
          });
          // setTimeout(async () => {
          //   this.setState({ templateId: res.data.id });
          // }, 3000);

          console.log("template id im sending", res.data.id);

          history.push({
            pathname: "/show",
            state: { action: "edit", templateId: res.data.id },
          });
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            this.handleBack();
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function EnhancedTableHead(props) {
    const {
      classes,
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      onRequestSort,
    } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {/* <TableCell padding="checkbox">
                  <Checkbox />
                </TableCell> */}
          {headCells.map((headCell, index) => (
            <TableCell
              style={{
                borderTop: "1px solid #dadada",
                borderLeft: headCell.borderLeft ? "1px solid #dadada" : "none",
                borderRight: headCell.borderRight
                  ? "1px solid #dadada"
                  : "none",
                padding: "7px",
                fontWeight: "bold",
                color: Colors.globalColor8,
                textTransform: "capitalize",
                backgroundColor:"#f2f2f2",
                textAlign: language === "ar" ? "right" : "left",
              }}
              key={headCell.id}
              width={index == 0 && "50%"}
              align={headCell.numeric ? "left" : "center"}
              padding={headCell.disablePadding ? "none" : "default"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {/* <TableSortLabel
                      active={orderBy === headCell.id}
                      direction={orderBy === headCell.id ? order : "asc"}
                      onClick={createSortHandler(headCell.id)}
                    > */}
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
              {/* </TableSortLabel> */}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    const { numSelected } = props;

    return "";
  };

  EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
  };

  let industryData = useSelector((state) => state.industryArrReducer.industry);

  useEffect(
    () => {
      setIndustries(industryData);
    },
    [industryData]
  );

  let userData = useSelector((state) => state.userReducer.user);

  useEffect(
    () => {
      setToken(userData.token);
      setCurrentIndustry(userData.industry_id);
      getIndustriesTemplates(userData.industry_id, userData.token);
    },
    [userData]
  );

  useEffect(() => {
    getPackageDetails();
  }, []);

  let teamArray = useSelector((state) => state.teamReducer.team);

  console.log("teamArray", teamArray);

  useEffect(
    () => {
      setTeam(teamArray.data);
      let _team = [];
      teamArray.data.forEach((item) => {
        _team.push({
          ...item,
          checked: false,
        });
        setTeamArr(_team);
      });
    },
    [teamArray]
  );

  console.log("teamArr&&&&&&&&&&&&&&&&&&&", teamArr);

  let company = useSelector((state) => state.companyReducer.company);
  React.useEffect(
    () => {
      setCurrentCompany(company);
      let localstorage = localStorage.getItem("UserData");
      var data = JSON.parse(localstorage);
      setCurrentUser(data);
      getTemplates(company, true);
      getPermissions();
    },
    [company?.id]
  );

  // const getInspection = () => {
  //   let localstorage = localStorage.getItem("UserData");
  //   var data = JSON.parse(localstorage);
  //   let token = data.token;
  //   let params = {
  //     user_id: data.user_id,
  //   };
  //   console.log(data.user_id);
  //   let query = Object.keys(params)
  //     .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
  //     .join("&");

  //   fetch(GlobalApi + "/Inspection/get_all_inspections_share?" + query, {
  //     method: "GET",
  //     headers: {
  //       Authorization: "Bearer " + token,
  //       "Content-Type": "application/json",
  //     },
  //   })
  //     .then((responseJson) => responseJson.json())
  //     .then(async (response) => {
  //       if (response.status === "Success") {
  //         if (response.data) {
  //           setRows(response.data);

  //           // setInspection(response.data);
  //           console.log(response, "{}{}{}{}");
  //         }
  //       } else if (
  //         response.error === "jwt expired" ||
  //         response.error === "invalid token" ||
  //         response.error === "invalid signature" ||
  //         response.error === "Unexpected token"
  //       ) {
  //         let status = await refresh_token();
  //         console.log(status);
  //         if (status) {
  //           console.log("opopopop");
  //           getInspection();
  //         }
  //       }
  //     })
  //     .catch((error) => console.log(error.message));
  //   console.log("op");
  // };

  const getTemplates = async (
    currentCompany,
    reset = false,
    _selectedAccess = undefined,
    _selectedUsers = undefined
  ) => {
    setTempLoader(true);
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data == undefined) {
      return <Redirect to={"/signin"} />;
    }

    var params = {
      skip: 0,
      noOfRecords: 15,
      company_id: currentCompany.id,
      user_id: data.user_id,
      access_to: JSON.stringify(_selectedUsers == undefined ? selectedUsers : _selectedUsers),
      shared_with: JSON.stringify(_selectedAccess == undefined ? selectedAccess : _selectedAccess),
      from_d: reset ? undefined : datesFilters.startDate,
      to_d: reset ? undefined : moment(datesFilters.endDate).add(1, "d").format("YYYY-MM-DD"),
    };

    console.log("::::::::::::::::::::::::::::::::::::::", params);

    var token = data.token;
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    await fetch(
      GlobalApi + "/TemplateShare/get_all_archived_template_shares_for_user?" + query,
      {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then(async (res) => {
        if (res.status === "Success") {
          setTotalRecords(res.total_records);
          console.log(res.data);
          var result = res.data;
          var templateList = [];
          await result.map((data) => {
            var template = {
              id: data.id,
              name: data.title,
              description: data.description,
              scheduled: data.Schedules?.length > 0 ? "Yes" : "no",
              modified: "",
              shared: data.TemplateShares?.length > 1 ? "Yes" : "no",
              createdBy: data.created_by,
              createdAt: data.createdAt,
              status: data.status,
              report_template_id: data.report_template_id,
              TemplateShares: data.TemplateShares,
              created_by: data.created_by,
            };
            templateList.push(template);
          });

          setRows(
            templateList.sort(
              (a, b) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            )
          );
          setTempLoader(false);
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
          }
        }
      })
      .catch((err) => {
        setTempLoader(false);
        console.log(err, "error");
      });
  };

  const getMoreTemplates = async (
    currentCompany,
    reset = false,
    page_no = 0
  ) => {
    // setTempLoader(true)
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data == undefined) {
      return <Redirect to={"/signin"} />;
    }

    var params = {
      skip: rows?.length,
      noOfRecords: 15,
      company_id: currentCompany.id,
      user_id: data.user_id,
      access_to: JSON.stringify(selectedUsers),
      shared_with: JSON.stringify(selectedAccess),
      from_d: reset ? undefined : datesFilters.startDate,
      to_d: reset
        ? undefined
        : moment(datesFilters.endDate)
            .add(1, "d")
            .format("YYYY-MM-DD"),
    };
    console.log("::::::::::::::::::::::::::::::::::::::::::::::", params);

    var token = data.token;
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    await fetch(
      GlobalApi + "/TemplateShare/get_all_archived_template_shares_for_user?" + query,
      {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then(async (res) => {
        console.log(
          "YEYEYEYEYEYE________________________________________________________________________________________________________________________",
          res
        );
        if (res.status === "Success") {
          setTotalRecords(res.total_records);
          console.log(res.data);
          var result = res.data;
          var templateList = [...rows];
          await result.map((data) => {
            var template = {
              id: data.id,
              name: data.title,
              description: data.description,
              scheduled: data.Schedules?.length > 0 ? "Yes" : "no",
              modified: "",
              shared: data.TemplateShares?.length > 1 ? "Yes" : "no",
              createdBy: data.created_by,
              createdAt: data.createdAt,
              status: data.status,
              report_template_id: data.report_template_id,
              TemplateShares: data.TemplateShares,
              created_by: data.created_by,
            };
            templateList.push(template);
          });

          setRows(
            templateList.sort(
              (a, b) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            )
          );
          setTempLoader(false);
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
          }
        }
      })
      .catch((err) => {
        setTempLoader(false);
        console.log(err, "error");
      });
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows?.length - page * rowsPerPage);
  const ModalOpen = (row) => {
    setIsModalOpen(row);
  };

  const clearDatesFilter = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
    setFilterApplied(false);
    setDateFilters(_datesFilters);
    getTemplates(currentCompany, true);
  };

  const clearUsersFilter = () => {
    setSelectedUsers([]);
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      getTemplates(currentCompany, false, selectedAccess, []);
    } else {
      getTemplates(currentCompany, true, selectedAccess, []);
    }
  };

  const clearOwnerFilter = () => {
    let _selectedAccess = [...selectedAccess];
    const nextselectedAccess = _selectedAccess.filter((t) => t !== "owner");
    if (nextselectedAccess.length == 0) {
      setAppliedFilters({ ...appliedFilters, Access: false });
    }
    setSelectedAccess(nextselectedAccess);
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      setFilterApplied(true);
      getTemplates(currentCompany, false, nextselectedAccess);
    } else {
      setFilterApplied(false);
      getTemplates(currentCompany, true, nextselectedAccess);
    }
  };

  const clearSharedFilter = () => {
    let _selectedAccess = [...selectedAccess];
    const nextselectedAccess = _selectedAccess.filter((t) => t !== "shared");
    if (nextselectedAccess.length == 0) {
      setAppliedFilters({ ...appliedFilters, Access: false });
    }
    setSelectedAccess(nextselectedAccess);
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      setFilterApplied(true);
      getTemplates(currentCompany, false, nextselectedAccess);
    } else {
      setFilterApplied(false);
      getTemplates(currentCompany, true, nextselectedAccess);
    }
  };

  const getPackageDetails = async () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data == undefined) {
      return <Redirect to={"/signin"} />;
    }
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

  
    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  };

  const changeIndustry = (e) => {
    console.log("Industry Value", e.target.value);
    setCurrentIndustry(e.target.value);
    getIndustriesTemplates(e.target.value, token);
  };

  function getIndustriesTemplates(industry_Id, Token) {
    console.log("get industries function called>>>>>>>>>>");
    let data = localStorage.getItem("UserData");
    let params = { industry_id: industry_Id };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    fetch(
      GlobalApi + "/Template/get_all_public_templates_industries?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + Token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("response from get all pubnlic >>>>>>>>>>", response);
        if (response.status === "Success") {
          console.log("templates >>>>>>>>>>>>>>>>", response);
          setTemplates(response.data);
        }
      })
      .catch((error) => console.log(error.message));
  }

  return <Grid container justifyContent="center" alignItems="center" className="scrollHidden " style={{ backgroundColor: "white", padding: "5px 0px", borderRadius: "5px", marginTop: "0px", overflowY: "hidden", width: "100%" }}>
  <Grid item xs={12} md={12} lg={12} style={{ padding: "5px 20px 0px" }}>

    <div>
      <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", overflow: "hidden", width: "100%" }}>
        <Grid container justifyContent="space-between" alignItems="center" spacing={2} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: "white", padding: "0px", borderRadius: "5px" }}>
          <Grid item xs={12} lg={4} style={{alignItems:'center', display:'flex'}}>
            <TextField size="small" autoComplete="off" InputProps={{ startAdornment: <InputAdornment position="start">
                    <img src={search} width={12} />
                  </InputAdornment>, endAdornment: <InputAdornment position="end">
                    <Tooltip title="Filter Options">
                      <img src={filter} width={20} style={{ cursor: "pointer" }} onClick={handleClick3} />
                    </Tooltip>
                  </InputAdornment>, classes: { input: classes.resize } }} placeholder={t("Search in existing Templates")} fullWidth onChange={(e) => setSearchText(e.target.value)} variant="outlined" style={{ width: "100%", marginTop: window.innerWidth < 700 ? "10px" : 0, backgroundColor: Colors.globalColor5 }} />

            {/* =================================popover 1=========================== */}

            <Popover open={Boolean(filterMenu1)} anchorEl={filterMenu1} onClose={handleClose3} anchorOrigin={{ vertical: "bottom", horizontal: "center" }} transformOrigin={{ vertical: "top", horizontal: "center" }}>
              <div style={{ width: "150px", minHeight: "100px", backgroundColor: "white", borderRadius: "5px", padding: "0px" }}>
                <List component="nav" aria-label="secondary mailbox folders">
                  <ListItem button style={{ paddingTop: "2px", paddingBottom: "2px" }} onClick={(e) => handleClick4(e)}>
                    <ListItemText primary={t("Access")} />
                  </ListItem>
                  <ListItem button style={{ paddingTop: "2px", paddingBottom: "2px" }} onClick={(e) => handleClick5(e)}>
                    <ListItemText primary={t("Shared with")} />
                  </ListItem>
                  <ListItem button style={{ paddingTop: "2px", paddingBottom: "2px" }} onClick={(e) => handleClick6(e)}>
                    <ListItemText primary={t("Dates")} />
                  </ListItem>
                </List>
              </div>
            </Popover>

            {/* =================================popover 2=========================== */}
            <Popover open={Boolean(filterMenu2)} anchorEl={filterMenu2} onClose={handleClose4} anchorOrigin={{ vertical: "center", horizontal: "right" }} transformOrigin={{ vertical: "center", horizontal: "left" }} style={{ margin: "20px" }}>
              <div style={{ width: "300px", minHeight: "100px", backgroundColor: "white", borderRadius: "5px", padding: "10px" }}>
                <TextField size="small" autoComplete="off" InputProps={{ startAdornment: <InputAdornment position="start">
                        <img src={search} width={12} />
                      </InputAdornment>, classes: { input: classes.resize } }} placeholder={t("Search")} fullWidth variant="outlined" style={{ backgroundColor: Colors.globalColor5 }} value={userFilter} onChange={(e) => setUserFilter(e.target.value)} />

                <br />
                <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                  {t("Users")}
                </p>
                <div className="scrollbarShow2" style={{ maxHeight: "100px", overflowY: "scroll" }}>
                  {teamArr
                    .filter((word) => word.first_name
                          .toLowerCase()
                          .includes(
                            userFilter.toLowerCase()
                          ) || word.last_name
                          .toLowerCase()
                          .includes(
                            userFilter.toLowerCase()
                          ) || (
                          word.first_name +
                          " " +
                          word.last_name
                        )
                          .toLowerCase()
                          .includes(userFilter.toLowerCase()))
                    .map((item, index) => {
                      return <span style={{ display: "block" }}>
                          <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} onChange={(e) => selectUsers(e.target.checked, item)} defaultChecked={selectedUsers.indexOf(item.id) > -1} />
                          <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                            {item.first_name}
                          </p>
                          &nbsp;
                          <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                            {item.last_name}
                          </p>
                        </span>;
                    })}
                </div>

                <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 20 }} />
                <Button className="ctBtn" onClick={() => handleDone()}>
                  {t("Done")}
                </Button>
              </div>
            </Popover>

            {/* =================================popover 3=========================== */}
            <Popover open={Boolean(filterMenu3)} anchorEl={filterMenu3} onClose={handleClose5} anchorOrigin={{ vertical: "center", horizontal: "right" }} transformOrigin={{ vertical: "center", horizontal: "left" }} style={{ margin: "20px" }}>
              <div style={{ width: "300px", minHeight: "100px", backgroundColor: "white", borderRadius: "5px", padding: "10px" }}>
                <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                  {t("Selected Filters")}
                </p>
                {selectedAccess.indexOf("owner") > -1 && <span style={{ display: "block" }}>
                    <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} defaultChecked={true} onChange={(e) => selectAccess(e.target.checked, "owner")} />
                    {t("Owned by me")}
                  </span>}

                {selectedAccess.indexOf("shared") > -1 && <span style={{ display: "block" }}>
                    <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} defaultChecked={true} onChange={(e) => selectAccess(e.target.checked, "shared")} />
                    {t("Shared with me")}
                  </span>}

                <br />
                <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                  {t("All Filters")}
                </p>
                {selectedAccess.indexOf("owner") <= -1 && <span style={{ display: "block" }}>
                    <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} onChange={(e) => selectAccess(e.target.checked, "owner")} />
                    {t("Owned by me")}
                  </span>}

                {selectedAccess.indexOf("shared") <= -1 && <span style={{ display: "block" }}>
                    <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} onChange={(e) => selectAccess(e.target.checked, "shared")} />
                    {t("Shared with me")}
                  </span>}
                <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 20 }} />
                <Button className="ctBtn" onClick={() => handleDone()}>
                  {t("Done")}
                </Button>
              </div>
            </Popover>

            {/* =================================popover 4=========================== */}
            <Popover open={Boolean(filterMenu4)} anchorEl={filterMenu4} onClose={handleClose6} anchorOrigin={{ vertical: "center", horizontal: "right" }} transformOrigin={{ vertical: "center", horizontal: "left" }} style={{ margin: "20px" }}>
              <div style={{ width: "300px", minHeight: "100px", backgroundColor: "white", borderRadius: "5px", padding: "10px" }}>
                <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                  {t("Select Date Range")}
                </p>
                <span style={{ display: "block" }}>
                  <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.today} onChange={() => handleToday()} />
                  <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                    {t("Today")}
                  </p>
                </span>
                <span style={{ display: "block" }}>
                  <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.yesterday} onChange={() => handleYesterday()} />
                  <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                    {t("Yesterday")}
                  </p>
                </span>
                <span style={{ display: "block" }}>
                  <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.last7} onChange={() => handle7Days()} />
                  <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                    {t("Last 7 Days")}
                  </p>
                </span>
                {/* <span style={{ display: "block" }}>
          <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.last15} onChange={()=>handle15Days()} />
          <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
            Last 15 Days
          </p>
        </span> */}
                <span style={{ display: "block" }}>
                  <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.lastMonth} onChange={() => handle1Month()} />
                  <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                    {t("Last Month")}
                  </p>
                </span>
                <p className="label2" style={{ marginTop: "20px", fontSize: 14, fontWeight: "bold" }}>
                  {t("Custom Range")}
                </p>

                {/* <KeyboardDatePicker className="filterDatePicker" disableToolbar label="From Date"  format="MM/dd/yyyy" margin="normal" id="date-picker-inline" value={datesFilters.startDate} onChange={handleStartDate} KeyboardButtonProps={{ "aria-label": "change date" }} /> */}
                {/* <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 0, width: "100%", marginBottom: 10 }} /> */}
                <form className={classes.container} noValidate>
                  <TextField variant="outlined" className="filterDatePicker" label={t("From Date")} type="date" size="small" fullwidth value={datesFilters.startDate} onChange={handleStartDate} style={{ width: "100%", marginTop: "10px" }} InputLabelProps={{ shrink: true }} />
                  <TextField variant="outlined" className="filterDatePicker" label={t("To Date")} type="date" size="small" fullwidth value={datesFilters.endDate} onChange={handleEndDate}  style={{ width: "100%", marginTop: "10px" }} InputLabelProps={{ shrink: true }} />
                  {/* <KeyboardDatePicker className="filterDatePicker" style={{ marginTop: "10px", marginBottom: "10px" }} disableToolbar label="To Date" variant="outlined" format="MM/dd/yyyy" margin="normal" id="date-picker-inline" value={datesFilters.endDate} onChange={handleEndDate} KeyboardButtonProps={{ "aria-label": "change date" }} /> */}
                </form>
                <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 10, width: "100%", marginBottom: 20 }} />
                <Button className="ctBtn" onClick={() => handleDone2()}>
                  {/* onClick={() => onSelectAccess()} */}
                  {t("Done")}
                </Button>
              </div>
            </Popover>
          </Grid>

          {/* only show this row if there is any filter applied */}
          {(filterApplied || selectedUsers.length > 0 || selectedAccess.length > 0) && <Grid item xs={12} lg={6}>
              <div className="scrollHidden2" style={{ overflow: "auto", whiteSpace: "nowrap", display: "flex", paddingBottom: "5px" }}>
                {filterApplied && <div style={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                    <div style={{ backgroundColor: Colors.globalColor9, border: "1px solid #043077", color: "#043077", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                      <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px" }}>
                        {datesFilters.today && "Today"}
                        {datesFilters.yesterday && "Yesterday"}
                        {!datesFilters.today && !datesFilters.yesterday && `From : ${moment(datesFilters.startDate).format("DD-MM-YY")} - To: ${moment(datesFilters.endDate).format("DD-MM-YY")}`}
                      </div> <div onClick={() => clearDatesFilter()} style={{ display: "inline", padding: "0px 5px", cursor: "pointer" }}>
                        x
                      </div>
                    </div>
                  </div>}
                &nbsp;
                {selectedUsers.length > 0 && appliedFilters.Users && <div style={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                    <div style={{ border: "1px solid #043077", color: "#043077", overflow: "hidden", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                      <div style={{ display: "inline", borderRight: "1px solid #043077", padding: "5px", backgroundColor: Colors.globalColor9 }}>
                        {teamArr.filter((v) => v?.id == selectedUsers[0])[0].first_name} {selectedUsers.length > 1 && <>
                            {" "}
                            +{selectedUsers.length - 1}{" "}
                          </>}
                      </div> <div onClick={() => clearUsersFilter()} style={{ backgroundColor: Colors.globalColor9, display: "inline", padding: "5px", cursor: "pointer" }}>
                        x
                      </div>
                    </div>
                  </div>}
                &nbsp;
                {selectedAccess.length > 0 && appliedFilters.Access && selectedAccess.includes("owner") && <div style={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                    <div style={{ border: "1px solid #043077", color: "#043077", overflow: "hidden", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                      <div
                        style={{
                          display: "inline",
                          borderRight: "1px solid #043077",
                          padding: "5px",
                          backgroundColor: Colors.globalColor9,
                        }}
                      >
                        Owned By Me
                      </div> <div onClick={() => clearOwnerFilter()} style={{ backgroundColor: Colors.globalColor9, display: "inline", padding: "5px", cursor: "pointer" }}>
                        x
                      </div>
                    </div>
                  </div>}
                &nbsp;
                {selectedAccess.length > 0 && appliedFilters.Access && selectedAccess.includes("shared") && <div style={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}>
                    <div style={{ border: "1px solid #043077", color: "#043077", overflow: "hidden", height: "100%", borderRadius: "5px", display: "inline-flex", alignItems: "center" }}>
                      <div
                        style={{
                          display: "inline",
                          borderRight: "1px solid #043077",
                          padding: "5px",
                          backgroundColor: Colors.globalColor9,
                        }}
                      >
                        Shared With Me
                      </div> <div onClick={() => clearSharedFilter()} style={{ backgroundColor: Colors.globalColor9, display: "inline", padding: "5px", cursor: "pointer" }}>
                        x
                      </div>
                    </div>
                  </div>}
              </div>
            </Grid>}

          <Grid item xs={12} sm={12} md={2} style={{ textAlign: window.innerWidth > 700 ? (language == "ar"  ? "left" :"right")  : "center" }}>
            {searchText == "" && <p className="label2" style={{ textAlign: window.innerWidth > 700 ? (language == "ar"  ? "left" :"right")  : "center", display: "inline", marginTop: 8, fontSize: 12, color: "grey", textTransform: "capitalized" }}>
                {t("showing records")} {rows?.length} {t("of")} {totalRecords}
              </p>}
          </Grid>
        </Grid>
      </div>
    </div>
  </Grid>
  <div style={{ padding: "0px 5px 5px ", width: "100%" }}>
    <div className="scrollbarShow2" style={{ overflow: "hidden", width: "100%" }}>
      {tempLoader && <div style={{ width: "100%", textAlign: "center", padding: 20 }}>
          <Spinner />
        </div>}
      {!tempLoader && <Grid container justifyContent="center" spacing={1} style={{ padding:window.innerWidth > 500 ? "20px" : "5px", height: "61vh" }}>
          {!tempLoader && rows?.length == 0 && <div style={{ padding: "20px", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
              <NoRecords />
            </div>}

          {!tempLoader && rows?.length !== 0 && <>
              {/* For Tablet and Desktop*/}
              {window.innerWidth > 500 && <TableContainer className={classes.container} id="TemplateScroll" onScroll={(e) => handleScroll(e)}>
                  <Table className="scrollHidden templateTable"  stickyHeader aria-label="sticky table" style={{ borderLeft: "1px solid #dadada", borderRight: "1px solid #dadada" }}>
                    <EnhancedTableHead classes={classes} numSelected={selected.length} order={order} orderBy={orderBy} onRequestSort={handleRequestSort} rowCount={rows?.length} />
                    <TableBody classname="scrollHidden">
                      {rows?.length !== 0 ? stableSort(rows?.filter((v) => v?.name
                                ?.toLowerCase()
                                .includes(
                                  searchText?.toLowerCase()
                                ) || v?.status
                                ?.toLowerCase()
                                .includes(
                                  searchText?.toLowerCase()
                                ) || v?.scheduled
                                ?.toLowerCase()
                                .includes(
                                  searchText?.toLowerCase()
                                )), getComparator(order, orderBy)).map(
                          (row, index) => {
                            const isItemSelected = isSelected(
                              row.name
                            );
                            const labelId = `enhanced-table-checkbox-${index}`;

                            console.log("PPPPPPPPPP", row)

                            return (
                              <>
                                <TableRow
                                  hover
                                  onClick={(event) =>
                                    handleClick(event, row.name)
                                  }
                                  role="checkbox"
                                  aria-checked={isItemSelected}
                                  tabIndex={-1}
                                  key={row.id}
                                  className="testingtable new-hover"
                                >
                                  <TableCell
                                    component="th"
                                    id={labelId}
                                    scope="row"
                                    padding="none"
                                    style={
                                      {
                                        padding: "3px 10px",
                                        minWidth: 200,
                                        textAlign:language == "ar" ? "right" : "left",
                                      } // align="right"
                                    }
                                  >
                                    <>
                                      <Tooltip title={row?.name}>
                                        <p
                                          style={{
                                            margin: "3px  0px",
                                          }}
                                        >
                                          {row.name.slice(0, 30) +
                                            (row.name.length > 30
                                              ? "..."
                                              : "")}
                                        </p>
                                      </Tooltip>

                                      {/* <Tooltip title={row?.description}>
                                    <p
                                      style={{
                                        margin: "5px 0px",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {row.description &&
                                        row.description.slice(
                                          0,
                                          30
                                        ) +
                                          (row.description.length >
                                          30
                                            ? "..."
                                            : "")}
                                    </p>
                                  </Tooltip> */}
                                    </>
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: "3px 10px",
                                      textAlign: "center",
                                      borderLeft:
                                        "1px solid #dadada",
                                      borderRight:
                                        "1px solid #dadada",
                                    }}
                                  >
                                     <p
                                          style={{
                                            margin: "3px  0px",
                                          }}
                                        >
                                      {row.status}{" "}
                                    </p>
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: "3px 10px",
                                      textAlign: "center",
                                    }}
                                  >
                                     <p
                                          style={{
                                            margin: "3px  0px",
                                          }}
                                        >
                                      {row.scheduled}
                                    </p>
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: "3px 10px",
                                      textAlign: "center",
                                      borderLeft:"1px solid #dadada",
                                        borderRight: language == "ar" ? "1px solid #dadada" : "none",
                                    }}
                                  >
                                    <p
                                          style={{
                                            margin: "3px  0px",
                                          }}
                                        >
                                      {row?.shared}{" "}
                                    </p>
                                  </TableCell>

                                

                                  <TableCell
                                    style={{
                                      padding: "2px 10px",
                                      textAlign: "center",
                                      verticalAlign: "middle",
                                
                                      borderLeft:
                                        "1px solid #dadada",
                                    }}
                                  >
                                    <img
                                      src={dots}
                                      alt="open modal"
                                      style={{ cursor: "pointer" }}
                                      onMouseOver={(e) =>
                                        (e.currentTarget.src = dotsH)
                                      }
                                      width={30}
                                      onMouseOut={(e) =>
                                        (e.currentTarget.src = dots)
                                      }
                                      onClick={(e) => {
                                        setCurrentEditRow(row);
                                        handleClick2(e);
                                      }}
                                    />
                                    <Menu
                                      id="simple-menu"
                                      className="extraMenuBox"
                                      anchorEl={anchorEl}
                                      keepMounted
                                      open={Boolean(anchorEl)}
                                      onClose={handleClose2}
                                    >
                                      {/* "Manage Report Preferences" */}
                                      {userData?.super_admin ==
                                        true ||
                                      permissions_obj["Admin"] ==
                                        true ||
                                      permissions_obj[
                                        "Template Creation"
                                      ] == true ? (
                                        <MenuItem
                                          onClick={() =>restoreTemplate(currentEditRow?.id)
                                          }
                                        >
                                          <img
                                            src={restore}
                                            width={20}
                                            alt="file"
                                          />
                                          &nbsp; {t("Restore Template")}
                                        </MenuItem>
                                      ) : (
                                        <MenuItem disabled>
                                          <img
                                            src={restoreG}
                                            width={20}
                                            alt="file"
                                          />
                                          &nbsp;{t("Restore Template")}
                                        </MenuItem>
                                      )}

                                      {/* {userData?.super_admin ==
                                        true ||
                                      permissions_obj["Admin"] ==
                                        true ||
                                      permissions_obj[
                                        "Template Creation"
                                      ] == true ? (
                                        <>
                                          {(currentEditRow?.created_by ===
                                          currentUser.user_id ? (
                                            true
                                          ) : currentEditRow?.TemplateShares?.filter(
                                              (v) =>
                                                v?.user_id ===
                                                currentUser.user_id
                                            )[0] !== undefined ? (
                                            currentEditRow?.TemplateShares?.filter(
                                              (v) =>
                                                v?.user_id ===
                                                currentUser?.user_id
                                            )[0]?.isEditor === true
                                          ) : (
                                            false
                                          )) ? (
                                            <MenuItem
                                              onClick={() =>deleteTemplate(currentEditRow.id)
                                              }
                                            >
                                              <img
                                                src={Delete}
                                                width={20}
                                                alt="file"
                                              />
                                              &nbsp;Delete Template
                                            </MenuItem>
                                          ) : (
                                            <MenuItem
                                              disabled={true}
                                              style={{
                                                cursor:
                                                  "not-allowed",
                                              }}
                                            >
                                              <img
                                                src={DeleteG}
                                                width={20}
                                                alt="file"
                                              />
                                              &nbsp;Delete Template
                                            </MenuItem>
                                          )}
                                        </>
                                      ) : (
                                        <MenuItem
                                          disabled={true}
                                          style={{
                                            cursor: "not-allowed",
                                          }}
                                        >
                                          <img
                                            src={DeleteG}
                                            width={20}
                                            alt="file"
                                          />
                                          &nbsp;Delete Template
                                        </MenuItem>
                                      )} */}
                                    </Menu>
                                  </TableCell>
                                </TableRow>
                              </>
                            );
                          }
                        ) : <TableRow>
                          <TableCell colSpan={6}>
                            <NoRecords />
                          </TableCell>
                        </TableRow>}
                    </TableBody>
                  </Table>
                </TableContainer>}

              {window.innerWidth <= 500 && <div className={classes.container} style={{overflowY:'scroll',width:'100%', padding:'5px'}} id="TemplateScroll" onScroll={(e) => handleScroll(e)}>
                  {rows?.length !== 0 && stableSort(rows?.filter((v) => v?.name
                            ?.toLowerCase()
                            .includes(
                              searchText?.toLowerCase()
                            ) || v?.status
                            ?.toLowerCase()
                            .includes(
                              searchText?.toLowerCase()
                            ) || v?.scheduled
                            ?.toLowerCase()
                            .includes(
                              searchText?.toLowerCase()
                            )), getComparator(order, orderBy)).map(
                      (row, index) => {
                        return <div className="hover shadow" style={{ display: "flex", justifyContent: "space-between", border: "1px solid #dadada", padding: "10px", margin: "5px", flexDirection: "row", alignItems: "center", textAlign: "left", height: "100px", borderRadius: "5px", backgroundColor: "white", overflow: "hidden" }}>
                            <div>
                              <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "14px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                                {row.name.slice(0, 30) + (row.name.length > 30 ? "..." : "")}
                              </p>

                              <p style={{ fontSize: "12px", textAlign: "left", marginBottom: "0px", marginTop: "0px" }}>
                                {row.description && row.description.slice(0, 30) + (row.description.length > 30 ? "..." : "")}
                              </p>
                            </div>
                            <div>
                              <img src={dotsH} alt="open modal" style={{ cursor: "pointer" }} width={30} onClick={(e) => {
                                  setCurrentEditRow(row);
                                  handleClick2(e);
                                }} />
                                  <Menu
                                      id="simple-menu"
                                      className="extraMenuBox"
                                      anchorEl={anchorEl}
                                      keepMounted
                                      open={Boolean(anchorEl)}
                                      onClose={handleClose2}
                                    >

{userData?.super_admin ==
                                        true ||
                                      permissions_obj["Admin"] ==
                                        true ||
                                      permissions_obj[
                                        "Template Creation"
                                      ] == true ? (
                                        <MenuItem
                                          onClick={() =>restoreTemplate(currentEditRow?.id)
                                          }
                                        >
                                          <img
                                            src={restore}
                                            width={20}
                                            alt="file"
                                          />
                                          &nbsp;{t("Restore Template")}
                                        </MenuItem>
                                      ) : (
                                        <MenuItem disabled>
                                          <img
                                            src={restoreG}
                                            width={20}
                                            alt="file"
                                          />
                                          &nbsp; {t("Restore Template")}
                                        </MenuItem>
                                      )}
                                    </Menu>
                            </div>

                            {/* <div style={{ width: "100%" }}>
                          {value.due && <div>
                              <div style={{ display: "flex", flexDirection: "row" }}>
                                <img src={due_date} width={15} height={15} />
                                &nbsp;
                                <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
                                  {moment(value.due).format("MM-DD-YYYY")}
                                </p>
                              </div>
                            </div>}
                            <div style={{ display: "flex", flexDirection: "row" }}>
                            <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
                                  Active Since :  
                                </p>
                                &nbsp;
                                <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
                                {moment(value.updatedAt).fromNow()}
                                </p>
                                </div>
                                <div style={{ display: "flex", flexDirection: "row" }}>
                            <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
                                  Status :  
                                </p>
                                &nbsp;
                                <p className="label2" style={{ marginBottom: 5, fontSize: 12, marginTop: 0, color: "grey", textTransform: "capitalized" }}>
                                {value.status ? value.status : "To Do"}
                                </p>
                                </div>
                        </div> */}

                            {/* <div style={{ width: "100%", display: "flex", align: "center", flexDirection: "row", justifyContent: "space-between" }}>
                          <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>
                            {(value.Users != null || value.Users != undefined) && value.Users.map(
                                (v, i) => {
                                  if (i <= 2) {
                                    return (
                                      <Tooltip
                                        title={`${v ? v?.first_name : ""} ${
                                          v ? v?.last_name : ""
                                        }`}
                                        aria-label=""
                                      >
                                        {v?.avatar !== null ? (
                                          <div
                                            style={{
                                              width: 30,
                                              height: 30,
                                              borderRadius: "50px",
                                              color: "#043077",
                                              display: "flex",
                                              justifyContent: "center",
                                              margin: 1,
                                              alignItems: "center",
                                              backgroundImage: `url(https://server.uraudits.com/view?Key=${
                                                v?.avatar
                                              })`,
                                              backgroundSize: "cover",
                                            }}
                                          />
                                        ) : (
                                          <div
                                            style={{
                                              width: 30,
                                              height: 30,
                                              borderRadius: "50px",
                                              border: "1px solid #043077",
                                              color: "#043077",
                                              display: "flex",
                                              justifyContent: "center",
                                              margin: 1,
                                              alignItems: "center",
                                            }}
                                          >
                                            <p
                                              style={{
                                                margin: 0,
                                                fontWeight: "bold",
                                                fontSize: "10px",
                                              }}
                                            >
                                              {v
                                                ? v?.first_name
                                                    .substring(0, 1)
                                                    .toUpperCase()
                                                    .concat(
                                                      v
                                                        ? v?.last_name
                                                            .substring(0, 1)
                                                            .toUpperCase()
                                                        : ""
                                                    )
                                                : ""}
                                            </p>
                                          </div>
                                        )}
                                      </Tooltip>
                                    );
                                  } else {
                                    return (
                                      <div
                                        style={{
                                          width: 30,
                                          height: 30,
                                          borderRadius: "50px",
                                          border: "1px solid #043077",
                                          color: "#043077",
                                          display: "flex",
                                          justifyContent: "center",
                                          margin: 1,
                                          alignItems: "center",
                                        }}
                                      >
                                        <p
                                          style={{
                                            margin: 0,
                                            fontWeight: "bold",
                                            fontSize: "10px",
                                          }}
                                        >
                                          +{value.Users.length - 3}
                                        </p>
                                      </div>
                                    );
                                  }
                                }
                              )}
                          </div>
                          <Link to={`/task/${value.id}`} style={{ color: "black" }}>
                          <div>
                            <img src={chat} alt="chat" />
                          </div>
                          </Link>
                        </div> */}
                          </div>;
                      }
                    )}
                </div>}
            </>}
        </Grid>}
    </div>
  </div>
</Grid>;
}

export default TemplateArchives;
